import MessagesHistory from './MessagesHistory';

export default MessagesHistory;
